import { render, staticRenderFns } from "./CourseOrderList.vue?vue&type=template&id=4d07a318"
import script from "./CourseOrderList.vue?vue&type=script&lang=js"
export * from "./CourseOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports